import styled, { css } from "styled-components";
import { Theme } from "@tvg/design-system";

type props = {
  selectedColumn: number | null;
  selectedLine: number | null;
  columnNumber: number | null;
  lineNumber: number | null;
  theme: Theme;
  top?: boolean;
  side?: boolean;
  isMatrix?: boolean;
  isHeader?: boolean;
};
export const PicksSelectorCellContainer = styled.div`
  & > * {
    opacity: ${(props: props) =>
      props.isMatrix &&
      props.selectedColumn !== props.columnNumber &&
      props.columnNumber !== null
        ? "0.4"
        : ""};
  }

  ${(props: props) =>
    props.isHeader &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}

  ${(props: props) =>
    props.isMatrix &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  background: ${(props: props) =>
    (props.selectedColumn === props.columnNumber &&
      props.columnNumber !== null) ||
    (props.selectedLine === props.lineNumber && props.lineNumber !== null)
      ? `${props.theme.colors.blue["000"]}`
      : ""};
  width: 100%;
  height: 100%;
  ${(props: {
    selectedColumn: number | null;
    selectedLine: number | null;
    columnNumber: number | null;
    lineNumber: number | null;
    theme: Theme;
    top?: boolean;
    side?: boolean;
  }) =>
    props.top &&
    css`
      box-shadow: inset 0px -1px 0px ${props.theme.colors.blue["200"]};
      border-top: 4px solid transparent;
    `}

  ${(props: props) =>
    props.side &&
    ((props.selectedColumn === props.columnNumber &&
      props.columnNumber !== null) ||
      (props.selectedLine === props.lineNumber && props.lineNumber !== null)) &&
    css`
      border-left: 4px solid ${props.theme.colors.blue_accent["500"]};
      border-right: 4px solid transparent;
    `}
  
  ${(props: props) =>
    props.top &&
    ((props.selectedColumn === props.columnNumber &&
      props.columnNumber !== null) ||
      (props.selectedLine === props.lineNumber && props.lineNumber !== null)) &&
    css`
      border-top: 4px solid ${props.theme.colors.blue_accent["500"]};
    `}
`;
